var hotel = [
  {
    id: 0,
    title: "Light bright airy stylish apt & safe peaceful stay",
    image: "https://i.ibb.co/HC5bSLc/Rectangle-26.png",
    guest: 4,
    bedroom: 2,
    bed: 2,
    bath: 2,
    condition: "Wif Air conditioning kitchen",
    terms: "Cancellation flexibility available",
    rating: 4.9,
    ratingnumber: 20,
    price: 34,
    totalprice: 167,
  },
  {
    id: 1,
    title: "Apartment in Lost Panaroma",
    image: "https://i.ibb.co/cD9jK0C/Rectangle-27.png",
    guest: 4,
    bedroom: 2,
    bed: 2,
    bath: 2,
    condition: "Wif Air conditioning kitchen",
    terms: "Cancellation flexibility available",
    rating: 4.8,
    ratingnumber: 10,
    price: 52,
    totalprice: 167,
  },
  {
    id: 2,
    title: "AR Lounge & Pool (r&r + b&b)",
    image: "https://i.ibb.co/2FXTBVL/Rectangle-28.png",
    guest: 4,
    bedroom: 2,
    bed: 2,
    bath: 2,
    condition: "Wif Air conditioning kitchen",
    terms: "Cancellation flexibility available",
    rating: 4.9,
    ratingnumber: 25,
    price: 44,
    totalprice: 167,
  },
];

export default hotel;
